var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsWalkthrough(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 214,
    viewBox: "0 0 274 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_315_1562)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_315_1562)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11C2 5.47715 6.47715 1 12 1H262C267.523 1 272 5.47715 272 11V211H2V11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M258.531 -3H16.4687C5.16413 -3 -4 6.99101 -4 19.3155V188.684C-4 201.009 5.16413 211 16.4687 211H258.531C269.836 211 279 201.009 279 188.684V19.3155C279 6.99101 269.836 -3 258.531 -3Z",
    fill: "#1467B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05985 211H265.94C278.118 211 288 200.963 288 188.592V179H-17V188.592C-17 200.963 -7.11839 211 5.05985 211Z",
    fill: "#9FC1DF",
    fillOpacity: 0.89
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44379 179.1H114.928L114.928 113.637L6.44379 113.637L6.44379 179.1Z",
    fill: "#AFBAEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 116.624H114.752V96.1381L4 111.696V116.624Z",
    fill: "#3E51A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01347 116.61L114.765 116.61V111.682L4.01347 111.682V116.61Z",
    fill: "#606CC6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M188.333 179.019H85.6721V88.427L137.002 72.9506L188.333 88.427V179.019Z",
    fill: "#C5CDFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M230 175H7V179H230V175Z",
    fill: "#9FAFFF"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M188.156 72.7876H85.4958V88.237H188.156V72.7876Z",
    fill: "#606CC6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5403 89.7982L136.826 72.7876L193.355 89.7846L80.5403 89.7982Z",
    fill: "#C5CDFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5403 89.7982V84.7615L99.8723 79.1004L97.8902 84.5172L80.5403 89.7982Z",
    fill: "#606CC6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M193.356 89.7846V85.1688L184.436 81.8835V87.1102L193.356 89.7846Z",
    fill: "#606CC6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M124.35 72.9506L137.26 69L150.157 72.9506L142.921 74.6204L136.826 72.7876L127.078 75.7336L124.35 72.9506Z",
    fill: "#606CC6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M125.11 178.638V144.224C125.11 137.409 130.662 131.856 137.477 131.856C144.292 131.856 149.845 137.409 149.845 144.224V178.638H125.123H125.11Z",
    fill: "#3E51A3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M137.478 135.63C142.216 135.63 146.071 139.486 146.071 144.224V178.638H128.884V144.224C128.884 139.486 132.74 135.63 137.478 135.63Z",
    fill: "#5363BC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M138.645 136.798C140.722 136.798 142.623 137.531 144.116 138.753C142.541 136.838 140.152 135.617 137.478 135.617C132.726 135.617 128.884 139.459 128.884 144.21V178.625H130.052V145.378C130.052 140.626 133.894 136.784 138.645 136.784V136.798Z",
    fill: "#5363BC"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M113.707 134.245V103.89H95.1891V134.245H113.707Z",
    fill: "#7391FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M111.833 105.777H97.0894V132.372H111.833V105.777Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M111.833 108.397L97.0894 117.452V105.777H111.833V108.397Z",
    fill: "#9FAFFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M115.403 131.055H93.5054V135.06H115.403V131.055Z",
    fill: "#E6EAFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M113.367 112.049H96.4377V113.61H113.367V112.049Z",
    fill: "#7391FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M113.367 129.494H96.4377V131.055H113.367V129.494Z",
    fill: "#7391FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M105.316 104.704H103.606V131.055H105.316V104.704Z",
    fill: "#7391FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M115.403 133.363H93.5054V135.141H115.403V133.363Z",
    fill: "#9FAFFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M179.061 134.259V103.903H160.543V134.259H179.061Z",
    fill: "#7391FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M177.174 105.777H162.43V132.372H177.174V105.777Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M177.174 108.397L162.43 117.452V105.777H177.174V108.397Z",
    fill: "#9FAFFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M180.744 131.055H158.846V135.06H180.744V131.055Z",
    fill: "#E6EAFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M178.707 112.049H161.778V113.61H178.707V112.049Z",
    fill: "#7391FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M178.707 129.494H161.778V131.055H178.707V129.494Z",
    fill: "#7391FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M170.657 104.704H168.946V131.055H170.657V104.704Z",
    fill: "#7391FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M180.744 133.363H158.846V135.141H180.744V133.363Z",
    fill: "#9FAFFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M143.071 153.442C143.071 154.283 142.392 154.962 141.55 154.962C140.709 154.962 140.03 154.283 140.03 153.442C140.03 152.6 140.709 151.921 141.55 151.921C142.392 151.921 143.071 152.6 143.071 153.442Z",
    fill: "#9FAFFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M149.831 174.606H125.11V179.019H149.831V174.606Z",
    fill: "#E6EAFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M146.057 170.534H128.87V174.606H146.057V170.534Z",
    fill: "#AEBEFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.34
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4958 83.2954L124.92 72.7876H85.4958V83.2954Z",
    fill: "#9FAFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.34
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M150.157 72.9506L188.156 83.2546V72.7876L150.157 72.9506Z",
    fill: "#9FAFFF"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M85.6722 89.7982L137.002 74.9598L188.333 90.1511V90.6399H85.6042L85.6722 89.7982Z",
    fill: "#9FAFFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7219 155.302V134.843H16.3815V155.302H28.7219Z",
    fill: "#7391FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M27.188 136.214H17.9158V152.559H27.188V136.214Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0972 143.029H16.9514V143.83H28.0972V143.029Z",
    fill: "#7391FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3366 135.63H20.4949V143.653H21.3366V135.63Z",
    fill: "#7391FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8935 135.63H24.0518V143.653H24.8935V135.63Z",
    fill: "#7391FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1472 155.342H14.9558V157.827H30.1472V155.342Z",
    fill: "#E6EAFF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M30.1472 156.768H14.9558V157.867H30.1472V156.768Z",
    fill: "#9FAFFF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4343 155.302V134.843H39.0939V155.302H51.4343Z",
    fill: "#7391FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9002 136.214H40.6279V152.559H49.9002V136.214Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8096 143.029H39.6638V143.83H50.8096V143.029Z",
    fill: "#7391FF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M44.049 135.63H43.2073V143.653H44.049V135.63Z",
    fill: "#7391FF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6056 135.63H46.7639V143.653H47.6056V135.63Z",
    fill: "#7391FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8596 155.342H37.6682V157.827H52.8596V155.342Z",
    fill: "#E6EAFF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M52.8596 156.768H37.6682V157.867H52.8596V156.768Z",
    fill: "#9FAFFF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1465 155.302V134.843H61.806V155.302H74.1465Z",
    fill: "#7391FF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6122 136.214H63.3398V152.559H72.6122V136.214Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5217 143.029H62.376V143.83H73.5217V143.029Z",
    fill: "#7391FF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7612 135.63H65.9194V143.653H66.7612V135.63Z",
    fill: "#7391FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3178 135.63H69.4761V143.653H70.3178V135.63Z",
    fill: "#7391FF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5717 155.342H60.3804V157.827H75.5717V155.342Z",
    fill: "#E6EAFF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M75.5717 156.768H60.3804V157.867H75.5717V156.768Z",
    fill: "#9FAFFF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M211.833 155.302V134.843H199.492V155.302H211.833Z",
    fill: "#7391FF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M210.298 136.214H201.026V152.559H210.298V136.214Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M211.194 143.029H200.048V143.83H211.194V143.029Z",
    fill: "#7391FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M204.447 135.63H203.605V143.653H204.447V135.63Z",
    fill: "#7391FF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M208.004 135.63H207.162V143.653H208.004V135.63Z",
    fill: "#7391FF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M213.258 155.342H198.066V157.827H213.258V155.342Z",
    fill: "#E6EAFF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M213.258 156.768H198.066V157.867H213.258V156.768Z",
    fill: "#9FAFFF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M234.545 155.302V134.843H222.204V155.302H234.545Z",
    fill: "#7391FF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M233.011 136.214H223.738V152.559H233.011V136.214Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M233.907 143.029H222.761V143.83H233.907V143.029Z",
    fill: "#7391FF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M227.16 135.63H226.318V143.653H227.16V135.63Z",
    fill: "#7391FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M230.716 135.63H229.875V143.653H230.716V135.63Z",
    fill: "#7391FF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M235.97 155.342H220.779V157.827H235.97V155.342Z",
    fill: "#E6EAFF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M235.97 156.768H220.779V157.867H235.97V156.768Z",
    fill: "#9FAFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_315_1562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.492 33.1799H183.508V83.0172H264.492V33.1799Z",
    fill: "white",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.053 65.9502H196.061V72.841H198.053V65.9502Z",
    fill: "#C5CDFF",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.481 64.5H199.489V72.8374H201.481V64.5Z",
    fill: "#C5CDFF",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.912 62.888H202.92V72.841H204.912V62.888Z",
    fill: "#C5CDFF",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.34 61.8552H206.348V72.841H208.34V61.8552Z",
    fill: "#C5CDFF",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.772 65.1333H209.78V72.841H211.772V65.1333Z",
    fill: "#C5CDFF",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.199 59.5235H213.208V72.841H215.199V59.5235Z",
    fill: "#C5CDFF",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.631 62.2331H216.639V72.841H218.631V62.2331Z",
    fill: "#C5CDFF",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.059 61.8552H220.067V72.841H222.059V61.8552Z",
    fill: "#C5CDFF",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.49 59.9013H223.499V72.841H225.49V59.9013Z",
    fill: "#C5CDFF",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.918 60.4051H226.926V72.841H228.918V60.4051Z",
    fill: "#C5CDFF",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.35 59.7754H230.358V72.841H232.35V59.7754Z",
    fill: "#C5CDFF",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.777 59.3328H233.786V72.8374H235.777V59.3328Z",
    fill: "#C5CDFF",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.209 64.3129H237.217V72.841H239.209V64.3129Z",
    fill: "#C5CDFF",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.637 65.6371H240.645V72.841H242.637V65.6371Z",
    fill: "#C5CDFF",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.068 65.889H244.077V72.841H246.068V65.889Z",
    fill: "#C5CDFF",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.579 72.895H189.599",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.579 69.4982H189.599",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.579 66.1013H189.599",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.579 62.708H189.599",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.579 59.3112H189.599",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.602 42.5968C197.602 40.024 195.422 37.9585 192.803 38.1385C190.62 38.2896 188.841 40.0348 188.657 42.2082C188.552 43.446 188.953 44.5867 189.678 45.4539C190.338 46.242 190.699 47.2387 190.699 48.2642V48.876H195.541V48.2642C195.541 47.2387 195.899 46.242 196.559 45.4539C197.208 44.6803 197.598 43.6799 197.598 42.5932L197.602 42.5968Z",
    fill: "#C5CDFF",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.542 48.8796H190.699V50.0742H195.542V48.8796Z",
    fill: "white",
    stroke: "#5460C6",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.699 50.0778H195.541V50.3693C195.541 50.8659 195.137 51.2725 194.636 51.2725H191.601C191.103 51.2725 190.696 50.8694 190.696 50.3693V50.0778H190.699Z",
    fill: "white",
    stroke: "#5460C6",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.309 51.2689H194.932V51.5603C194.932 52.0569 194.527 52.4635 194.026 52.4635H192.215C191.717 52.4635 191.309 52.0605 191.309 51.5603V51.2689Z",
    fill: "white",
    stroke: "#5460C6",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.237 42.6184H200.29",
    stroke: "#5460C6",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.759 42.6184H187.838",
    stroke: "#5460C6",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.023 37.426V35.3749",
    stroke: "#5460C6",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.743 38.9085L198.161 37.4944",
    stroke: "#5460C6",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.888 47.7425L189.324 46.3103",
    stroke: "#5460C6",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.263 38.8689L187.888 37.4944",
    stroke: "#5460C6",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.161 47.7425L196.79 46.3751",
    stroke: "#5460C6",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.409 42.129V37.9118H259.805V53.1292H249.922",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.111 53.1292H228.409V44.3744",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.34 41.5857H238.935",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.93 41.5857H257.525",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.34 43.3345H238.935",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.93 43.3345H257.525",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.34 45.0833H238.935",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.869 46.8321H238.935",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.34 46.8321H232.844",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.34 48.5809H238.935",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.93 48.5809H257.525",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.824 50.3297H238.935",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.34 50.3297H235.539",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.58 46.3067H258.225",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.599 46.3067H253.909",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.21 59.5991H258.928",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.21 62.924H258.928",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.21 66.2488H258.928",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.861 69.5701H258.928",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.21 69.5701H255.36",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.21 72.895H258.928",
    stroke: "#5460C6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.754 79.3749L181.186 87.5504L186.244 137.132L266.813 128.956L261.754 79.3749Z",
    fill: "white",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.17 97.6229C195.39 99.7819 193.813 101.714 191.644 101.934C189.479 102.153 187.542 100.581 187.322 98.4182C187.101 96.2592 190.475 90.4982 190.475 90.4982C190.475 90.4982 194.946 95.4639 195.166 97.6229H195.17Z",
    fill: "#C5CDFF",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.948 94.0462C192.882 95.2516 193.914 96.7629 194.004 97.6517C194.048 98.0655 194.004 98.4685 193.889 98.8392",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.936 100.268C192.489 100.638 191.933 100.887 191.312 100.948C190.897 100.991 190.493 100.948 190.122 100.833",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.742 96.8025C197.887 98.2023 196.866 99.4509 195.462 99.5948C194.058 99.7388 192.806 98.7204 192.666 97.3207C192.521 95.9209 194.708 92.193 194.708 92.193C194.708 92.193 197.602 95.4063 197.746 96.8061L197.742 96.8025Z",
    fill: "#C5CDFF",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.657 94.4852C196.263 95.266 196.93 96.2448 196.988 96.8205C197.017 97.0868 196.988 97.3495 196.912 97.5905",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.296 98.5117C196.007 98.7528 195.646 98.9111 195.242 98.9543C194.975 98.9831 194.711 98.9543 194.47 98.8788",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.961 90.2766L228.186 93.3994L229.552 106.792L260.327 103.669L258.961 90.2766Z",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.963 90.2753L228.188 93.3981L228.507 96.5269L259.282 93.4041L258.963 90.2753Z",
    fill: "#C5CDFF",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.443 104.782L188.213 112.111L189.845 128.106L262.075 120.777L260.443 104.782Z",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.442 104.781L188.213 112.11L188.565 115.561L260.794 108.232L260.442 104.781Z",
    fill: "#C5CDFF",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.596 105.363L206.471 104.057",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.007 105.932L192.193 105.507",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.7 107.259L206.756 106.846",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.292 108.72L200.91 107.439",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.406 118.929L204.277 117.623",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.535 116.583L227.406 115.276",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.665 114.233L250.532 112.927",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.463 97.7561L257.333 96.4499",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.419 100.059L257.637 99.4293",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.766 100.736L250.268 100.174",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.901 123.765L204.771 122.459",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.03 121.419L227.897 120.113",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.219 118.047L251.026 117.763",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.155 119.069L245.794 118.295",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.814 140.247L186.248 132.043L181.172 181.623L261.738 189.826L266.814 140.247Z",
    fill: "white",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.231 151.282L207.694 153.16",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.588 155.459L207.409 155.949",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.946 154.07L200.286 155.225",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.297 146.22L231.523 143.086L230.152 156.478L260.926 159.612L262.297 146.22Z",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.295 146.222L231.521 143.089L231.201 146.218L261.975 149.351L262.295 146.222Z",
    fill: "#C5CDFF",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.588 150.63L259.459 151.94",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.409 154.74L259.152 154.916",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.285 153.606L255.876 154.581",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.476 145.882C202.655 143.157 202.207 139.186 199.475 137.012C196.742 134.839 192.76 135.285 190.581 138.01C188.401 140.735 188.849 144.707 191.581 146.88C194.314 149.054 198.296 148.607 200.476 145.882Z",
    fill: "#C5CDFF",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.728 142.383C200.083 138.916 198.491 135.913 196.171 135.677C193.852 135.441 191.683 138.06 191.328 141.528C190.973 144.996 192.566 147.998 194.885 148.235C197.205 148.471 199.373 145.851 199.728 142.383Z",
    fill: "#C5CDFF",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.898 142.084C196.545 145.553 195.642 148.302 194.885 148.223C194.127 148.147 193.802 145.272 194.156 141.804C194.509 138.335 195.412 135.586 196.169 135.665C196.927 135.744 197.252 138.615 196.898 142.084Z",
    fill: "#C5CDFF",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.933 136.795L200.156 137.633",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.966 146.266L199.189 147.104",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.299 141.314L201.827 142.588",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.302 169.99L259.542 174.901",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.307 167.55L209.639 169.82",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.734 170.522L259.967 170.749",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.729 163.397L256.071 170.353",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.129 161.587L260.39 166.6",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.155 159.248L209.596 161.429",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.705 176.844L246.415 178.057L242.518 173.915L237.665 174.621L231.462 165.902L224.137 172.645L222.763 171.008L211.851 173.642L203.574 167.107L195.072 171.785L188.996 170.868L185.734 174.092L185.413 177.24L258.539 184.682L258.95 180.68L250.705 176.844Z",
    fill: "#C5CDFF",
    stroke: "#606CC6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.281 44V41.2H205.269C205.461 41.2 205.631 41.2387 205.777 41.316C205.924 41.3933 206.039 41.5013 206.121 41.64C206.204 41.776 206.245 41.9347 206.245 42.116C206.245 42.292 206.207 42.4493 206.129 42.588C206.052 42.7267 205.944 42.836 205.805 42.916C205.669 42.9933 205.511 43.032 205.329 43.032H204.745V44H204.281ZM204.745 42.604H205.321C205.455 42.604 205.564 42.5587 205.649 42.468C205.735 42.3773 205.777 42.26 205.777 42.116C205.777 41.9693 205.729 41.8507 205.633 41.76C205.537 41.6693 205.413 41.624 205.261 41.624H204.745V42.604ZM207.753 44L207.733 43.624V42.972C207.733 42.836 207.718 42.7227 207.689 42.632C207.662 42.5387 207.617 42.468 207.553 42.42C207.492 42.3693 207.409 42.344 207.305 42.344C207.209 42.344 207.125 42.364 207.053 42.404C206.981 42.444 206.92 42.5067 206.869 42.592L206.477 42.448C206.52 42.36 206.576 42.2787 206.645 42.204C206.717 42.1267 206.806 42.0653 206.913 42.02C207.022 41.9747 207.153 41.952 207.305 41.952C207.5 41.952 207.662 41.9907 207.793 42.068C207.924 42.1427 208.02 42.2507 208.081 42.392C208.145 42.5333 208.177 42.704 208.177 42.904L208.165 44H207.753ZM207.177 44.048C206.937 44.048 206.75 43.9947 206.617 43.888C206.486 43.7813 206.421 43.6307 206.421 43.436C206.421 43.228 206.49 43.0693 206.629 42.96C206.77 42.8507 206.966 42.796 207.217 42.796H207.753V43.14H207.361C207.182 43.14 207.057 43.1653 206.985 43.216C206.913 43.264 206.877 43.3333 206.877 43.424C206.877 43.5013 206.908 43.5627 206.969 43.608C207.033 43.6507 207.121 43.672 207.233 43.672C207.334 43.672 207.422 43.6493 207.497 43.604C207.572 43.5587 207.629 43.4987 207.669 43.424C207.712 43.3493 207.733 43.2653 207.733 43.172H207.865C207.865 43.444 207.81 43.6587 207.701 43.816C207.592 43.9707 207.417 44.048 207.177 44.048ZM208.904 44.848C208.84 44.848 208.768 44.836 208.688 44.812C208.611 44.788 208.536 44.7573 208.464 44.72L208.632 44.356C208.683 44.38 208.729 44.3987 208.772 44.412C208.815 44.428 208.849 44.436 208.876 44.436C208.94 44.436 208.993 44.4187 209.036 44.384C209.081 44.352 209.117 44.304 209.144 44.24L209.38 43.688L210.056 42H210.544L209.616 44.212C209.56 44.34 209.503 44.452 209.444 44.548C209.388 44.644 209.317 44.7173 209.232 44.768C209.147 44.8213 209.037 44.848 208.904 44.848ZM209.26 44L208.364 42H208.852L209.548 43.684L209.692 44H209.26ZM210.811 44V42H211.231L211.251 42.268C211.312 42.164 211.391 42.0853 211.487 42.032C211.583 41.9787 211.692 41.952 211.815 41.952C211.975 41.952 212.111 41.988 212.223 42.06C212.335 42.132 212.416 42.2413 212.467 42.388C212.525 42.2467 212.608 42.1387 212.715 42.064C212.821 41.9893 212.947 41.952 213.091 41.952C213.323 41.952 213.501 42.0267 213.627 42.176C213.752 42.3227 213.813 42.5493 213.811 42.856V44H213.367V42.976C213.367 42.816 213.349 42.6933 213.315 42.608C213.28 42.52 213.233 42.4587 213.175 42.424C213.116 42.3893 213.048 42.372 212.971 42.372C212.832 42.3693 212.724 42.4187 212.647 42.52C212.572 42.6213 212.535 42.7667 212.535 42.956V44H212.087V42.976C212.087 42.816 212.069 42.6933 212.035 42.608C212.003 42.52 211.957 42.4587 211.899 42.424C211.84 42.3893 211.772 42.372 211.695 42.372C211.556 42.3693 211.448 42.4187 211.371 42.52C211.296 42.6213 211.259 42.7667 211.259 42.956V44H210.811ZM215.16 44.048C214.965 44.048 214.792 44.004 214.64 43.916C214.49 43.8253 214.372 43.7013 214.284 43.544C214.198 43.3867 214.156 43.2053 214.156 43C214.156 42.7947 214.2 42.6133 214.288 42.456C214.376 42.2987 214.496 42.176 214.648 42.088C214.802 41.9973 214.978 41.952 215.176 41.952C215.354 41.952 215.516 41.9987 215.66 42.092C215.804 42.1827 215.917 42.3147 216 42.488C216.085 42.6613 216.128 42.868 216.128 43.108H214.556L214.616 43.052C214.616 43.1747 214.642 43.2813 214.696 43.372C214.749 43.46 214.82 43.528 214.908 43.576C214.996 43.624 215.093 43.648 215.2 43.648C215.322 43.648 215.424 43.6213 215.504 43.568C215.584 43.512 215.646 43.44 215.692 43.352L216.088 43.52C216.032 43.6267 215.96 43.72 215.872 43.8C215.786 43.88 215.684 43.9413 215.564 43.984C215.446 44.0267 215.312 44.048 215.16 44.048ZM214.644 42.82L214.58 42.764H215.708L215.648 42.82C215.648 42.7107 215.624 42.6213 215.576 42.552C215.528 42.48 215.466 42.4267 215.392 42.392C215.32 42.3547 215.244 42.336 215.164 42.336C215.084 42.336 215.004 42.3547 214.924 42.392C214.844 42.4267 214.777 42.48 214.724 42.552C214.67 42.6213 214.644 42.7107 214.644 42.82ZM216.471 44V42H216.891L216.919 42.368V44H216.471ZM217.827 44V42.976H218.275V44H217.827ZM217.827 42.976C217.827 42.816 217.808 42.6933 217.771 42.608C217.736 42.52 217.685 42.4587 217.619 42.424C217.555 42.3893 217.479 42.372 217.391 42.372C217.241 42.3693 217.125 42.4187 217.043 42.52C216.96 42.6213 216.919 42.7667 216.919 42.956H216.751C216.751 42.7453 216.781 42.5653 216.843 42.416C216.904 42.264 216.992 42.1493 217.107 42.072C217.221 41.992 217.357 41.952 217.515 41.952C217.675 41.952 217.811 41.984 217.923 42.048C218.037 42.112 218.124 42.212 218.183 42.348C218.244 42.4813 218.275 42.656 218.275 42.872V42.976H217.827ZM219.524 44.048C219.314 44.048 219.152 43.996 219.04 43.892C218.931 43.7853 218.876 43.6333 218.876 43.436V41.376H219.32V43.352C219.32 43.4453 219.342 43.516 219.384 43.564C219.43 43.612 219.495 43.636 219.58 43.636C219.607 43.636 219.636 43.6307 219.668 43.62C219.7 43.6093 219.736 43.5893 219.776 43.56L219.94 43.9C219.871 43.948 219.802 43.984 219.732 44.008C219.663 44.0347 219.594 44.048 219.524 44.048ZM218.544 42.384V42H219.86V42.384H218.544Z",
    fill: "#5363BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.62 95.5804L201.337 93.2214L200.483 93.3242L200.432 92.9032L202.601 92.6423L202.651 93.0633L201.797 93.166L202.081 95.525L201.62 95.5804ZM204.189 95.2714L204.124 94.9005L204.047 94.2531C204.03 94.1181 204.002 94.0073 203.962 93.9208C203.925 93.8313 203.871 93.7666 203.802 93.7266C203.735 93.6836 203.65 93.6683 203.547 93.6808C203.451 93.6922 203.37 93.7221 203.304 93.7704C203.237 93.8187 203.183 93.8883 203.143 93.9791L202.737 93.8829C202.769 93.7904 202.815 93.703 202.875 93.6206C202.937 93.5352 203.018 93.4636 203.119 93.4059C203.222 93.3478 203.349 93.3097 203.5 93.2916C203.693 93.2683 203.859 93.2873 203.998 93.3484C204.137 93.407 204.245 93.5027 204.323 93.6357C204.403 93.7684 204.455 93.934 204.479 94.1326L204.598 95.2222L204.189 95.2714ZM203.623 95.3878C203.385 95.4165 203.193 95.3859 203.048 95.2959C202.905 95.2056 202.823 95.0638 202.799 94.8705C202.774 94.664 202.824 94.4982 202.949 94.3731C203.076 94.2477 203.264 94.17 203.513 94.14L204.045 94.076L204.086 94.4175L203.697 94.4644C203.52 94.4857 203.398 94.5258 203.333 94.5847C203.267 94.641 203.24 94.7141 203.251 94.8041C203.26 94.8809 203.298 94.9382 203.364 94.9758C203.433 95.0106 203.523 95.0212 203.634 95.0078C203.734 94.9957 203.819 94.9627 203.888 94.9088C203.956 94.8549 204.006 94.7885 204.037 94.7095C204.07 94.6303 204.082 94.5444 204.07 94.4517L204.201 94.4359C204.234 94.706 204.205 94.9256 204.116 95.0949C204.025 95.2615 203.861 95.3592 203.623 95.3878ZM205.789 95.1272C205.657 95.1432 205.533 95.138 205.417 95.1116C205.301 95.0853 205.199 95.0412 205.111 94.9792C205.022 94.9147 204.951 94.8359 204.897 94.7431L205.261 94.526C205.31 94.5953 205.376 94.6505 205.459 94.6916C205.544 94.7323 205.635 94.747 205.73 94.7355C205.833 94.7231 205.913 94.696 205.97 94.6543C206.029 94.6095 206.055 94.5554 206.047 94.4919C206.04 94.431 206.01 94.3875 205.959 94.3615C205.907 94.3328 205.836 94.3131 205.746 94.3024L205.553 94.2733C205.36 94.2482 205.204 94.1905 205.085 94.0999C204.967 94.0068 204.899 93.8927 204.883 93.7577C204.859 93.5591 204.904 93.3979 205.018 93.2741C205.135 93.1499 205.314 93.0733 205.555 93.0443C205.676 93.0297 205.79 93.0348 205.895 93.0598C206.002 93.0818 206.097 93.1214 206.179 93.1787C206.261 93.2333 206.322 93.3026 206.361 93.3864L206.012 93.5977C205.978 93.5347 205.921 93.4904 205.843 93.4649C205.764 93.4368 205.68 93.4281 205.59 93.4389C205.5 93.4498 205.432 93.4781 205.387 93.5238C205.341 93.5669 205.322 93.6229 205.33 93.6918C205.335 93.7315 205.362 93.7658 205.411 93.7948C205.46 93.8212 205.528 93.8399 205.615 93.8508L205.856 93.8783C205.99 93.8944 206.102 93.932 206.192 93.9909C206.282 94.0473 206.352 94.1154 206.402 94.1953C206.452 94.2726 206.482 94.3536 206.492 94.4384C206.506 94.5575 206.484 94.6662 206.426 94.7645C206.371 94.8625 206.288 94.9437 206.178 95.008C206.067 95.0696 205.937 95.1094 205.789 95.1272ZM207.269 94.3369L206.962 94.0635L207.859 92.8154L208.395 92.7509L207.269 94.3369ZM206.91 94.944L206.576 92.164L207.021 92.1105L207.355 94.8905L206.91 94.944ZM208.173 94.792L207.351 93.8475L207.603 93.5029L208.702 94.7285L208.173 94.792ZM210.003 94.5718L209.669 91.7919L210.65 91.6739C210.841 91.6509 211.013 91.6678 211.168 91.7244C211.322 91.781 211.448 91.8706 211.546 91.9931C211.644 92.1129 211.703 92.2589 211.724 92.431C211.745 92.6031 211.719 92.7606 211.648 92.9035C211.579 93.046 211.474 93.1648 211.332 93.2597C211.19 93.352 211.024 93.4096 210.833 93.4326L210.341 93.4918L210.464 94.5164L210.003 94.5718ZM211.544 94.3865L210.757 93.3369L211.085 93.0477L212.065 94.3239L211.544 94.3865ZM210.29 93.0669L210.83 93.0019C210.92 92.9911 210.997 92.9616 211.061 92.9136C211.128 92.8653 211.178 92.8042 211.212 92.7303C211.249 92.656 211.262 92.5752 211.251 92.4878C211.236 92.3555 211.175 92.2526 211.069 92.1794C210.964 92.1061 210.836 92.0786 210.685 92.0967L210.18 92.1574L210.29 93.0669ZM213.34 94.2188C213.147 94.242 212.969 94.219 212.808 94.1498C212.649 94.0776 212.516 93.9687 212.41 93.823C212.307 93.677 212.243 93.502 212.218 93.2982C212.193 93.0943 212.216 92.909 212.284 92.7423C212.353 92.5756 212.457 92.4395 212.598 92.3339C212.74 92.2255 212.91 92.1594 213.106 92.1358C213.283 92.1145 213.449 92.1416 213.603 92.217C213.757 92.2898 213.885 92.4074 213.988 92.5696C214.093 92.7315 214.16 92.9316 214.189 93.1699L212.628 93.3576L212.681 93.2949C212.696 93.4167 212.735 93.5194 212.799 93.603C212.862 93.684 212.94 93.7431 213.033 93.7802C213.127 93.8174 213.226 93.8296 213.332 93.8168C213.454 93.8022 213.551 93.7636 213.624 93.7011C213.697 93.6359 213.751 93.557 213.785 93.4642L214.198 93.5837C214.155 93.6963 214.095 93.7975 214.017 93.8875C213.942 93.9771 213.848 94.0503 213.733 94.1069C213.622 94.1633 213.491 94.2006 213.34 94.2188ZM212.681 93.0612L212.611 93.0132L213.731 92.8785L213.678 92.9413C213.665 92.8327 213.63 92.7469 213.574 92.6838C213.518 92.618 213.451 92.5724 213.373 92.5469C213.297 92.5184 213.219 92.509 213.139 92.5185C213.06 92.5281 212.983 92.5562 212.908 92.6028C212.833 92.6468 212.773 92.7077 212.728 92.7855C212.684 92.8608 212.668 92.9526 212.681 93.0612ZM214.751 94.8064L214.417 92.0264L214.834 91.9762L214.906 92.3383L215.196 94.7528L214.751 94.8064ZM215.734 93.9307C215.567 93.9508 215.418 93.9258 215.286 93.8557C215.156 93.7827 215.05 93.6719 214.968 93.5233C214.885 93.3748 214.832 93.1959 214.806 92.9868C214.781 92.775 214.791 92.5884 214.836 92.4272C214.881 92.2634 214.957 92.1319 215.066 92.0329C215.178 91.9309 215.317 91.8698 215.484 91.8497C215.664 91.8281 215.825 91.853 215.968 91.9244C216.113 91.9929 216.232 92.1008 216.325 92.2481C216.42 92.3924 216.481 92.5704 216.506 92.7823C216.531 92.9914 216.515 93.1787 216.457 93.3442C216.402 93.5093 216.312 93.6437 216.187 93.7473C216.065 93.8479 215.914 93.9091 215.734 93.9307ZM215.574 93.539C215.68 93.5263 215.771 93.4885 215.846 93.4257C215.922 93.3602 215.978 93.2769 216.014 93.1759C216.053 93.0745 216.064 92.9616 216.05 92.8372C216.035 92.7128 215.997 92.6058 215.938 92.5162C215.882 92.4263 215.809 92.3598 215.721 92.3167C215.633 92.2736 215.534 92.2586 215.425 92.2717C215.325 92.2838 215.238 92.3211 215.165 92.3836C215.092 92.4461 215.039 92.5277 215.005 92.6285C214.974 92.7289 214.966 92.8413 214.981 92.9657C214.996 93.0902 215.031 93.1975 215.084 93.2877C215.141 93.3776 215.211 93.4457 215.294 93.4921C215.38 93.5355 215.473 93.5511 215.574 93.539ZM217.925 93.6671C217.726 93.691 217.544 93.6687 217.377 93.6001C217.212 93.5286 217.077 93.4199 216.971 93.2743C216.865 93.1286 216.8 92.9538 216.775 92.7499C216.75 92.5461 216.771 92.3609 216.837 92.1945C216.906 92.0278 217.011 91.8915 217.155 91.7857C217.297 91.6772 217.468 91.611 217.666 91.5871C217.865 91.5632 218.047 91.587 218.211 91.6586C218.375 91.7275 218.509 91.8349 218.612 91.9809C218.718 92.1266 218.784 92.3014 218.808 92.5053C218.833 92.7091 218.812 92.8943 218.746 93.0607C218.68 93.2271 218.576 93.3645 218.433 93.473C218.29 93.5789 218.121 93.6436 217.925 93.6671ZM217.876 93.2581C217.984 93.245 218.078 93.2069 218.156 93.1438C218.234 93.078 218.291 92.9959 218.328 92.8975C218.364 92.7964 218.375 92.6837 218.36 92.5593C218.345 92.4348 218.306 92.3293 218.245 92.2427C218.186 92.1531 218.111 92.0869 218.02 92.0442C217.928 91.9988 217.827 91.9828 217.716 91.9961C217.605 92.0095 217.51 92.0478 217.431 92.1109C217.353 92.1741 217.296 92.2562 217.26 92.3572C217.223 92.4583 217.213 92.571 217.228 92.6954C217.243 92.8199 217.28 92.9269 217.339 93.0165C217.4 93.1031 217.477 93.1691 217.568 93.2145C217.662 93.2569 217.764 93.2715 217.876 93.2581ZM219.48 92.36C219.454 92.1455 219.474 91.9645 219.54 91.817C219.605 91.6695 219.699 91.5548 219.82 91.473C219.945 91.3882 220.078 91.3372 220.221 91.32L220.272 91.745C220.15 91.7596 220.037 91.7907 219.933 91.8382C219.831 91.8827 219.751 91.946 219.694 92.0281C219.637 92.1102 219.615 92.2121 219.63 92.3339L219.48 92.36ZM219.313 93.4517L219.074 91.4661L219.519 91.4125L219.758 93.3982L219.313 93.4517ZM221.552 93.2307C221.343 93.2559 221.176 93.2235 221.053 93.1337C220.932 93.0408 220.859 92.8964 220.836 92.7005L220.589 90.6553L221.03 90.6022L221.266 92.5641C221.277 92.6568 221.307 92.7244 221.355 92.7669C221.406 92.8092 221.474 92.8252 221.558 92.815C221.585 92.8118 221.613 92.803 221.644 92.7886C221.674 92.7742 221.708 92.75 221.744 92.7161L221.947 93.0341C221.884 93.09 221.82 93.1341 221.754 93.1662C221.688 93.2009 221.621 93.2225 221.552 93.2307ZM220.38 91.6957L220.334 91.3145L221.641 91.1573L221.687 91.5385L220.38 91.6957Z",
    fill: "#5363BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.792 143.039L203.093 140.255L203.555 140.305L203.254 143.089L202.792 143.039ZM203.831 143.152L204.046 141.163L204.464 141.208L204.452 141.577L204.277 143.2L203.831 143.152ZM205.179 143.297L205.289 142.279L205.735 142.327L205.625 143.345L205.179 143.297ZM205.289 142.279C205.307 142.12 205.301 141.996 205.273 141.907C205.248 141.816 205.205 141.75 205.142 141.708C205.082 141.667 205.008 141.641 204.921 141.632C204.773 141.613 204.652 141.65 204.559 141.742C204.466 141.833 204.409 141.973 204.389 142.162L204.222 142.144C204.245 141.934 204.294 141.759 204.371 141.617C204.449 141.472 204.548 141.368 204.671 141.303C204.793 141.236 204.933 141.211 205.089 141.228C205.248 141.245 205.38 141.291 205.485 141.367C205.592 141.443 205.667 141.552 205.711 141.693C205.758 141.832 205.769 142.009 205.746 142.224L205.735 142.327L205.289 142.279ZM206.674 143.459L207.664 141.554L208.125 141.604L207.091 143.504L206.674 143.459ZM206.642 143.455L206.033 141.378L206.491 141.427L207.055 143.5L206.642 143.455ZM209.044 143.763C208.845 143.742 208.672 143.679 208.525 143.574C208.381 143.468 208.274 143.331 208.203 143.165C208.133 143 208.108 142.815 208.13 142.61C208.153 142.406 208.214 142.231 208.316 142.083C208.421 141.936 208.554 141.827 208.718 141.757C208.881 141.683 209.062 141.657 209.261 141.679C209.46 141.7 209.631 141.764 209.775 141.871C209.92 141.975 210.026 142.11 210.094 142.275C210.164 142.441 210.189 142.626 210.167 142.83C210.145 143.035 210.083 143.21 209.981 143.358C209.879 143.505 209.747 143.615 209.583 143.689C209.42 143.76 209.24 143.784 209.044 143.763ZM209.088 143.354C209.197 143.365 209.296 143.349 209.387 143.305C209.478 143.259 209.552 143.192 209.61 143.104C209.668 143.014 209.704 142.907 209.717 142.782C209.731 142.657 209.717 142.546 209.677 142.448C209.64 142.347 209.581 142.266 209.502 142.203C209.423 142.139 209.328 142.1 209.217 142.088C209.106 142.076 209.005 142.092 208.914 142.136C208.823 142.18 208.749 142.247 208.691 142.337C208.633 142.427 208.597 142.535 208.584 142.659C208.57 142.784 208.582 142.897 208.62 142.997C208.66 143.095 208.72 143.177 208.798 143.242C208.88 143.304 208.977 143.342 209.088 143.354ZM210.473 143.869L210.688 141.881L211.129 141.929L210.914 143.917L210.473 143.869ZM210.951 141.527C210.88 141.52 210.82 141.488 210.773 141.432C210.728 141.373 210.71 141.308 210.717 141.236C210.725 141.165 210.757 141.107 210.813 141.062C210.871 141.017 210.936 140.999 211.008 141.006C211.079 141.014 211.138 141.046 211.182 141.102C211.23 141.158 211.25 141.222 211.242 141.293C211.235 141.365 211.201 141.424 211.143 141.472C211.087 141.516 211.023 141.535 210.951 141.527ZM212.365 144.122C212.161 144.1 211.985 144.037 211.838 143.932C211.691 143.825 211.581 143.689 211.508 143.523C211.438 143.357 211.413 143.172 211.435 142.968C211.458 142.763 211.521 142.588 211.625 142.441C211.732 142.294 211.867 142.186 212.031 142.115C212.197 142.041 212.381 142.016 212.582 142.037C212.778 142.059 212.951 142.126 213.099 142.238C213.249 142.348 213.352 142.495 213.41 142.678L212.979 142.793C212.946 142.7 212.889 142.623 212.807 142.561C212.725 142.498 212.629 142.461 212.517 142.449C212.409 142.437 212.309 142.455 212.218 142.501C212.128 142.545 212.053 142.612 211.995 142.702C211.937 142.79 211.902 142.895 211.889 143.017C211.876 143.139 211.888 143.25 211.925 143.35C211.965 143.449 212.025 143.53 212.104 143.595C212.186 143.658 212.281 143.695 212.39 143.706C212.501 143.718 212.603 143.701 212.697 143.655C212.791 143.606 212.864 143.535 212.917 143.442L213.313 143.645C213.217 143.817 213.084 143.945 212.914 144.029C212.747 144.113 212.564 144.144 212.365 144.122ZM214.484 144.351C214.291 144.33 214.123 144.268 213.981 144.164C213.843 144.058 213.738 143.922 213.667 143.756C213.599 143.59 213.577 143.406 213.599 143.201C213.621 142.997 213.684 142.822 213.788 142.675C213.893 142.528 214.025 142.419 214.186 142.348C214.349 142.274 214.529 142.248 214.725 142.269C214.903 142.288 215.058 142.352 215.191 142.46C215.325 142.566 215.423 142.709 215.487 142.891C215.553 143.072 215.573 143.282 215.548 143.521L213.985 143.352L214.05 143.303C214.037 143.425 214.052 143.533 214.096 143.629C214.139 143.723 214.202 143.798 214.284 143.855C214.367 143.912 214.461 143.946 214.567 143.958C214.689 143.971 214.793 143.955 214.878 143.911C214.963 143.864 215.033 143.799 215.088 143.716L215.464 143.926C215.396 144.026 215.315 144.111 215.219 144.181C215.125 144.252 215.017 144.302 214.893 144.331C214.771 144.361 214.635 144.368 214.484 144.351ZM214.103 143.075L214.046 143.012L215.167 143.134L215.101 143.183C215.113 143.074 215.099 142.983 215.059 142.909C215.019 142.832 214.963 142.772 214.893 142.73C214.825 142.685 214.752 142.658 214.672 142.65C214.593 142.641 214.511 142.651 214.428 142.68C214.344 142.705 214.272 142.751 214.211 142.817C214.151 142.88 214.115 142.966 214.103 143.075ZM216.836 144.557L217.137 141.773L218.119 141.88C218.31 141.9 218.474 141.956 218.612 142.045C218.75 142.135 218.852 142.251 218.92 142.393C218.988 142.531 219.013 142.687 218.995 142.859C218.976 143.032 218.916 143.179 218.814 143.302C218.715 143.426 218.585 143.518 218.426 143.578C218.267 143.636 218.092 143.655 217.901 143.634L217.408 143.581L217.297 144.607L216.836 144.557ZM218.379 144.724L217.849 143.524L218.233 143.316L218.9 144.78L218.379 144.724ZM217.454 143.155L217.995 143.214C218.085 143.224 218.167 143.212 218.24 143.18C218.316 143.148 218.379 143.1 218.428 143.036C218.481 142.971 218.512 142.896 218.521 142.808C218.536 142.676 218.5 142.562 218.413 142.467C218.327 142.371 218.208 142.316 218.057 142.299L217.552 142.245L217.454 143.155ZM220.166 144.965C219.972 144.944 219.805 144.882 219.663 144.778C219.524 144.672 219.42 144.536 219.349 144.37C219.281 144.205 219.258 144.02 219.28 143.816C219.302 143.611 219.366 143.436 219.47 143.289C219.574 143.142 219.707 143.033 219.868 142.962C220.031 142.888 220.211 142.862 220.407 142.883C220.585 142.902 220.74 142.966 220.873 143.074C221.007 143.18 221.105 143.323 221.169 143.505C221.235 143.686 221.255 143.896 221.229 144.135L219.666 143.966L219.732 143.917C219.719 144.039 219.734 144.148 219.777 144.243C219.821 144.337 219.884 144.412 219.966 144.469C220.048 144.526 220.143 144.561 220.249 144.572C220.371 144.585 220.474 144.57 220.56 144.525C220.645 144.478 220.715 144.413 220.77 144.331L221.145 144.54C221.078 144.64 220.997 144.725 220.9 144.795C220.807 144.866 220.698 144.916 220.574 144.945C220.453 144.975 220.317 144.982 220.166 144.965ZM219.785 143.689L219.727 143.627L220.849 143.748L220.783 143.797C220.795 143.688 220.781 143.597 220.74 143.523C220.7 143.446 220.645 143.386 220.575 143.344C220.507 143.299 220.433 143.272 220.354 143.264C220.274 143.255 220.193 143.265 220.109 143.294C220.026 143.32 219.954 143.365 219.893 143.431C219.833 143.494 219.797 143.58 219.785 143.689ZM221.409 145.856L221.709 143.072L222.127 143.117L222.115 143.486L221.854 145.904L221.409 145.856ZM222.563 145.225C222.396 145.206 222.256 145.148 222.143 145.05C222.034 144.95 221.955 144.818 221.909 144.655C221.862 144.492 221.85 144.305 221.872 144.096C221.895 143.884 221.947 143.704 222.027 143.557C222.108 143.408 222.212 143.297 222.341 143.225C222.472 143.151 222.621 143.123 222.788 143.141C222.969 143.16 223.12 143.221 223.243 143.323C223.369 143.422 223.461 143.554 223.518 143.718C223.579 143.881 223.597 144.068 223.574 144.28C223.552 144.489 223.494 144.668 223.4 144.816C223.309 144.964 223.191 145.075 223.046 145.148C222.904 145.218 222.743 145.244 222.563 145.225ZM222.496 144.807C222.602 144.818 222.699 144.802 222.787 144.758C222.875 144.711 222.948 144.642 223.006 144.552C223.067 144.462 223.104 144.355 223.117 144.23C223.131 144.106 223.119 143.993 223.081 143.892C223.046 143.792 222.991 143.711 222.914 143.649C222.838 143.587 222.745 143.55 222.637 143.539C222.536 143.528 222.443 143.545 222.358 143.589C222.272 143.633 222.202 143.701 222.147 143.791C222.094 143.882 222.061 143.99 222.047 144.115C222.034 144.239 222.043 144.352 222.075 144.452C222.11 144.552 222.163 144.634 222.234 144.698C222.308 144.76 222.395 144.796 222.496 144.807ZM224.757 145.462C224.558 145.44 224.385 145.377 224.238 145.273C224.094 145.166 223.987 145.03 223.916 144.864C223.846 144.698 223.822 144.513 223.844 144.309C223.866 144.105 223.928 143.929 224.029 143.782C224.134 143.635 224.268 143.526 224.431 143.455C224.594 143.381 224.775 143.355 224.974 143.377C225.173 143.398 225.345 143.463 225.489 143.569C225.633 143.673 225.739 143.808 225.807 143.974C225.878 144.14 225.902 144.325 225.88 144.529C225.858 144.733 225.796 144.909 225.694 145.056C225.592 145.203 225.46 145.314 225.296 145.387C225.133 145.458 224.953 145.483 224.757 145.462ZM224.801 145.052C224.91 145.064 225.01 145.048 225.1 145.004C225.191 144.957 225.265 144.89 225.323 144.803C225.381 144.712 225.417 144.605 225.43 144.48C225.444 144.356 225.43 144.244 225.39 144.146C225.353 144.045 225.294 143.964 225.215 143.902C225.136 143.837 225.041 143.799 224.93 143.787C224.819 143.775 224.718 143.79 224.627 143.834C224.537 143.878 224.462 143.945 224.404 144.035C224.346 144.126 224.31 144.233 224.297 144.358C224.284 144.482 224.295 144.595 224.333 144.696C224.373 144.794 224.433 144.875 224.512 144.94C224.593 145.003 224.69 145.04 224.801 145.052ZM226.567 144.539C226.59 144.324 226.65 144.152 226.747 144.023C226.844 143.894 226.962 143.804 227.099 143.751C227.239 143.697 227.38 143.677 227.523 143.693L227.477 144.118C227.355 144.105 227.238 144.11 227.126 144.133C227.016 144.153 226.924 144.197 226.85 144.264C226.776 144.331 226.732 144.425 226.719 144.547L226.567 144.539ZM226.158 145.565L226.373 143.576L226.819 143.625L226.604 145.613L226.158 145.565ZM228.389 145.854C228.18 145.832 228.025 145.763 227.925 145.647C227.828 145.529 227.79 145.372 227.811 145.176L228.032 143.128L228.474 143.176L228.261 145.14C228.251 145.233 228.265 145.306 228.302 145.358C228.342 145.411 228.404 145.441 228.489 145.451C228.516 145.454 228.545 145.451 228.578 145.444C228.611 145.437 228.649 145.421 228.692 145.396L228.819 145.752C228.745 145.792 228.672 145.82 228.6 145.837C228.529 145.856 228.458 145.862 228.389 145.854ZM227.594 144.095L227.635 143.713L228.943 143.854L228.902 144.236L227.594 144.095Z",
    fill: "#5363BC"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_315_1562",
    x: 0,
    y: 0,
    width: 274,
    height: 214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_315_1562"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_315_1562",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_315_1562"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 11C2 5.47715 6.47715 1 12 1H262C267.523 1 272 5.47715 272 11V211H2V11Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_315_1562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 157,
    fill: "white",
    transform: "translate(181 33)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsWalkthrough);
export default __webpack_public_path__ + "static/media/ReportsWalkthrough.e96f33bd14539811f1ddf3d9ead66aa6.svg";
export { ForwardRef as ReactComponent };